import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Header, Input, Dimmer, Loader } from "semantic-ui-react";
import { ParseInputType } from "../../utils/UtilMethods";
import IPackBoxStatus from "../IPackBoxStatus/IPackBoxStatus";
import "./FinalizeSortModal.css";
import SharedFunctions from "../../utils/SharedFunctions";
import { FINALIZE_SORT_MODAL } from "../../utils/constants/componentConstants";

const FinalizeSortModal = ({
  open,
  sortID,
  articleScan,
  onClose,
  iPackWarningLampVisible,
  isLoading,
}) => {
  const [input, setInputState] = useState("");

  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(FINALIZE_SORT_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  };

  const prevOpen = usePrevious(open);

  const inputRef = React.createRef();

  useEffect(() => {
    if (open && !prevOpen) {
      let thisDimmer = [...document.getElementsByClassName("dimmer")].find((el) =>
        [...el.children].some((ch) => ch.classList.contains("FinalizeSortModal"))
      );
      thisDimmer.style.transition = "background-color 0s";
      thisDimmer.style.backgroundColor = "#4c4c4c";
    }
    focusInput();
  });

  const focusInput = () => {
    if (open && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const setInputValue = (ev) => {
    let value = ev.target.value;
    var parsedValue = parseInt(value);
    var newValue = "";
    if (parsedValue) {
      var parsedValueString = parsedValue.toString();
      if (parsedValue > 0) {
        newValue = parsedValueString;
      } else {
        newValue = parsedValueString.substr(0, parsedValueString.length - 1);
      }
    }
    setInputState(newValue);
  };

  const onInputKeyPress = (ev) => {
    if (ev.key === "Enter") {
      articleScan(input, ParseInputType(input));
      setInputState("");
      focusInput();
    }
  };

  const onInputBlur = () => {
    focusInput();
  };

  const onModalClose = () => {
    setInputState("");
    onClose();
  };

  return (
    <Modal
      open={open}
      size="small"
      className="FinalizeSortModal"
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Dimmer active={isLoading} inverted>
        <Loader size="big" />
      </Dimmer>
      <Header>
        <Header.Content>
          <h1>{`Färdig lista!`}</h1>
        </Header.Content>
      </Header>
      <Modal.Content>
        <h1>{`Skanna kvarvarande produkter`}</h1>
        <div className="InputContainer">
          <Input
            className="InputElement"
            autoFocus
            autoComplete="off"
            ref={inputRef}
            value={input}
            placeholder={""}
            onChange={(ev) => setInputValue(ev)}
            onBlur={() => onInputBlur()}
            onKeyPress={(ev) => onInputKeyPress(ev)}
            disabled={isLoading}
          />
          <IPackBoxStatus visible={iPackWarningLampVisible} size={"big"} />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={onModalClose}>
          KLAR
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default FinalizeSortModal;
